import request from '@/util/request'


export const suplierAdd = (data) => request.post('/api/suplierAdd', data);  //供应商添加

export const suplierEdit = (data) => request.post('/api/suplierEdit', data);  //供应商修改

export const suplierDetail = (data) => request.post('/api/suplierDetail', data);  //供应商详情

export const suplierList = (data) => request.post('/api/suplierList', data);  //供应商列表

export const suplierDel = (data) => request.post('/api/suplierDel', data);  //供应商删除